// extracted by mini-css-extract-plugin
export default {"logoPreview":"CustomLogoManager_logoPreview__J-Tc5","logoPreviewContainer":"CustomLogoManager_logoPreviewContainer__CxFv5"};